import ClassNames from "classnames";
import { FunctionComponent, MouseEventHandler, ReactNode } from "react";
import { LogoBackground } from "../../server/types/index.js";
import styles from "../stylesheets/components/media-library-image-item.module.css";
import { PictureCategory } from "../types/index.js";

interface Props {
  onClick?: MouseEventHandler<HTMLDivElement>;
  isSelected?: boolean;
  category?: PictureCategory;
  background?: LogoBackground;
  narrow?: boolean;
  title?: string;
  className?: string;
  children: ReactNode;
}

const MediaLibraryImageItem: FunctionComponent<Props> = ({
  isSelected = false,
  onClick,
  category,
  background,
  narrow,
  title,
  className,
  children,
}) => {
  return (
    <div
      className={ClassNames(styles.MediaLibrary__Image, className, {
        [styles["MediaLibrary__Image--logo"]]: category === "logo",
        [styles["MediaLibrary__Image--placeholder"]]:
          category === "placeholder",
        [styles["MediaLibrary__Image--dark"]]: background === "dark",
        [styles["MediaLibrary__Image--selected"]]: isSelected,
        [styles["MediaLibrary__Image--narrow"]]: narrow,
      })}
      title={title}
      onClick={onClick}
    >
      {children}
    </div>
  );
};

export default MediaLibraryImageItem;
